import React from "react";
import styled from "styled-components";

import Modal, { Box, ButtonContainer, Button, Title } from "./Modal";

import { fonts } from "./theme";
import Hourglass from "../assets/w_hourglass.png";

const Body = styled.div`
  padding: 32px 24px 34px;
  
  img {
    height: 102px;
    width: auto;
    margin: 20px 0;
  }

`;

const Message = styled.div`
  font-family: ${fonts.book};
  font-size: 17px;
  line-height: 24px;
  text-align: center;
`;

export default class SunsetModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }

  onConfirm = () => {
    this.setState({ isLoading: true });

    this.props.onRequestClose().catch(() => this.setState({ isLoading: false }));
  };

  render() {
    const { onRequestClose, ...props } = this.props;
    const { isLoading } = this.state;

    return (
      <Modal
        contentLabel="Mosaic"
        style={{
          content: {
            maxWidth: 300,
            width: "100%",
          },
        }}
        {...props}
      >
        <Box>
          <Body>
             <Title><img src={Hourglass} alt="Time" /></Title>
             <Title>The End, for now.</Title>
            <Message>
              Thank you for watching Mosaic. We are transitioning on to new projects, and Mosaic will no longer be available after January 30th, 2019. We appreciate your support, and can’t wait to share our new interactive experiences with you!
            </Message>
          </Body>
          <ButtonContainer>
            <Button
              disabled={isLoading}
              onClick={onRequestClose}
              autoFocus>
              OK
            </Button>
          </ButtonContainer>
        </Box>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SunsetModal.js